import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { Select } from '@/components/Form'

import { ScheduledIntervalType } from './interfaces'
import messages from './messages'
import { getMinutes } from './utils'

const StyledSelect = styled(Select)`
  flex-basis: 40%;
`
function Minutes({ readOnly = false, isUserSchedule = false }: ScheduledIntervalType) {
  const intl = useIntl()

  return (
    <StyledSelect
      disabled={readOnly}
      name={`triggerData.minutes`}
      className={''}
      label={intl.formatMessage(messages.every)}
      options={getMinutes(isUserSchedule)}
      variant={''}
      defaultValue={15}
    />
  )
}

export default Minutes
